// Web API client for Wooflect — mirrors the mobile src/lib/api.ts contract.
const BASE = process.env.REACT_APP_BACKEND_URL;

// NOTE: token key intentionally kept as "pawpal_token" to match internal identifiers.
const TOKEN_KEY = "pawpal_token";

export const storeToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export async function apiFetch(path, opts = {}, auth = true) {
  const headers = {
    "Content-Type": "application/json",
    ...(opts.headers || {}),
  };
  if (auth) {
    const token = getToken();
    if (token) headers["Authorization"] = `Bearer ${token}`;
  }
  const res = await fetch(`${BASE}/api${path}`, { ...opts, headers });
  const text = await res.text();
  let data;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = text;
  }
  if (!res.ok) {
    const detail = data?.detail || data || `HTTP ${res.status}`;
    const err = new Error(
      typeof detail === "string" ? detail : detail?.message || JSON.stringify(detail)
    );
    err.status = res.status;
    err.detail = detail;
    throw err;
  }
  return data;
}
